import { NUCLEOS, SECTORES, SECTORES_SIN_TORRES, SILOS, TIPO_POR_SECTOR, TIPOS_SILO } from '../../config/silos'

const estadoToShowMap = {
  D: 'Deshabilitado',
  U: 'En Uso',
  L: 'Lleno',
  V: 'Vacio'
}

function calculatePosicionEnXDesplazadaAlSector (posicionx, sector) {
  return sector === 'S4' ? (SECTORES_SIN_TORRES[sector].startingXPosition + SECTORES_SIN_TORRES[sector].xLarge / 3) + posicionx / 1.5
    : sector === 'S5' ? SECTORES_SIN_TORRES[sector].startingXPosition + posicionx * 2 + 1 : SECTORES_SIN_TORRES[sector].startingXPosition + posicionx
}

export const parseDataParaTablaPorSilos = (data) => {
  return data && data.filas ? data.filas
    .map((silo) => ({
      ...silo,
      metrosDeVacio: silo.metrosDeVacio ? silo.metrosDeVacio : silo.estado && silo.estado === 'L' ? 0 : silo.alturaTotal,
      cereal: silo.cereal ? silo.cereal.trim() : silo.cereal,
      cerealVariedad: silo.cerealVariedad ? silo.cerealVariedad.trim() : silo.cerealVariedad,
      color: silo.color ? silo.color.trim() : 'ffffff',
      cerealConColor: {
        color: silo.color ? silo.color.trim() : silo.color,
        cereal: silo.cereal ? silo.cereal.trim() : silo.cereal
      },
      posicionX: silo.posicionFisica ? Number.parseInt(silo.posicionFisica.slice(1, silo.posicionFisica.length - 1).split(',')[0]) : 0,
      posicionZ: silo.posicionFisica ? Number.parseInt(silo.posicionFisica.slice(1, silo.posicionFisica.length - 1).split(',')[1]) : 0,
      cerealVariedadConColor: {
        color: silo.color ? silo.color.trim() : silo.color,
        cerealVariedad: silo.cerealVariedad ? silo.cerealVariedad.trim() : silo.cerealVariedad
      },
      etiqueta: silo.etiqueta ? silo.etiqueta.trim() : silo.etiqueta,
      nombre: silo.nombre.trim(),
      nombreCortoToShow: ` ${silo.nombreCorto.trim()}  `,
      nombreCorto: silo.nombreCorto.trim(),
      nucleo: silo.nucleo ? silo.nucleo.trim() : silo.nucleo,
      observaciones: silo.observaciones ? silo.observaciones.trim() : silo.observaciones,
      sectorToShow: `  ${silo.sector.trim()} `,
      sector: silo.sector ? silo.sector.trim() : silo.sector,
      tipo: silo.tipo ? silo.tipo.trim() : silo.tipo,
      estadoToShow: silo.estado ? estadoToShowMap[silo.estado] : 'indefinido',
      fechaDeVaciado: silo.fechaDeVaciado ? silo.fechaDeVaciado.split('.')[0] : silo.fechaDeVaciado,
      fechaFinLlenado: silo.fechaFinLlenado ? silo.fechaFinLlenado.split('.')[0] : silo.fechaFinLlenado,
      fechaInicioLlenado: silo.fechaInicioLlenado ? silo.fechaInicioLlenado.split('.')[0] : silo.fechaInicioLlenado,
      fechaUltimoCubicaje: silo.fechaUltimoCubicaje ? silo.fechaUltimoCubicaje.split('.')[0] : silo.fechaUltimoCubicaje,
      fechaUltimoFumigado: silo.fechaUltimoFumigado ? silo.fechaUltimoFumigado.split('.')[0] : silo.fechaUltimoFumigado
    }))
    .map((silo) => ({ ...silo, operar: silo })) : []
}

export const parseDataForCuadroDeMando = (data) => {
  const unificarLineaYSector = (silo) =>
    `${silo.linea ? silo.linea.trim().toUpperCase() + '-' : ''}${
      silo.sector
        ? silo.sector.trim().toUpperCase() === 'S1' || silo.sector.trim().toUpperCase() === 'S2'
          ? 'S1-2'
          : silo.sector.trim().toUpperCase()
        : silo.sector
    }`
  const desplazarPosXS3yS4yS5abajo = (silo) => {
    const pos = silo.posicionFisica
      ? calculatePosicionEnXDesplazadaAlSector(
        Number.parseInt(silo.posicionFisica.slice(1, silo.posicionFisica.length - 1).split(',')[0]),
        silo.sector ? silo.sector.trim() : silo.sector
      )
      : 0
    return pos
  }
  const desplazarPosZS3yS4yS5abajo = (silo) => {
    const pos = silo.posicionFisica ? Number.parseInt(silo.posicionFisica.slice(1, silo.posicionFisica.length - 1).split(',')[1]) : 0
    return silo.sector
      ? silo.sector.trim().toUpperCase() === 'S3' || silo.sector.trim().toUpperCase() === 'S4' || silo.sector.trim().toUpperCase() === 'S5'
        ? pos + (SECTORES_SIN_TORRES['S3'].startingZPosition)
        : pos + 3 : pos
  }
  return data && data.filas ? data.filas.map((silo) => ({
    ...silo,
    sector: silo.sector ? silo.sector.trim() : silo.sector,
    linea: unificarLineaYSector(silo),
    posicionX: desplazarPosXS3yS4yS5abajo(silo),
    posicionZ: desplazarPosZS3yS4yS5abajo(silo)
  })) : []
}

export class MovimientoUtils {
  static getRadius (tipoSilo, sector) {
    let tipo = TIPO_POR_SECTOR[sector]
    if (tipo === 'GRANDE') {
      return SILOS[TIPOS_SILO.SILO_GRANDE].radio
    }
    tipo = tipoSilo === 'ENTRSILO' ? TIPOS_SILO.ENTRESILO : TIPOS_SILO.SILO_CHICO
    return SILOS[TIPOS_SILO.SILO_CHICO].radio
  }

  static getHeight (tipoSilo) {
    return SILOS[tipoSilo].height
  }

  static getSectorStartPosition (sector) {
    return SECTORES[sector.trim()].startingXPosition
  }

  static getNucleoColor (nucleo) {
    return NUCLEOS[nucleo] ? NUCLEOS[nucleo].color : 'white'
  }

  static getTopConeHeight (tipoSilo, sector) {
    return sector === 'S4'
      ? SILOS.SILO_GRANDE.topConeHeight
      : SILOS[tipoSilo === TIPOS_SILO.ENTRESILO ? TIPOS_SILO.ENTRESILO : TIPOS_SILO.SILO_CHICO].topConeHeight
  }

  static getBottomConeHeight (tipoSilo, sector) {
    return sector === 'S4'
      ? SILOS.SILO_GRANDE.bottomConeHeight
      : SILOS[tipoSilo === TIPOS_SILO.ENTRESILO ? TIPOS_SILO.ENTRESILO : TIPOS_SILO.SILO_CHICO].bottomConeHeight
  }

  static parseDataEstadoElevador (data) {
    return data.filas.map((cereal) => ({
      ...cereal,
      cereal: cereal.cereal ? cereal.cereal.trim() : cereal.cereal,
      cerealVariedad: cereal.cerealVariedad ? cereal.cerealVariedad.trim() : cereal.cerealVariedad
    }))
  }

  static parseData (data) {
    return data.filas
      .map((silo) => ({
        ...silo,
        metrosDeVacio: silo.metrosDeVacio ? silo.metrosDeVacio : silo.estado && silo.estado === 'L' ? 0 : silo.alturaTotal,
        cereal: silo.cereal ? silo.cereal.trim() : silo.cereal,
        cerealVariedad: silo.cerealVariedad ? silo.cerealVariedad.trim() : silo.cerealVariedad,
        color: silo.color ? silo.color.trim() : 'ffffff',
        cerealConColor: {
          color: silo.color ? silo.color.trim() : silo.color,
          cereal: silo.cereal ? silo.cereal.trim() : silo.cereal
        },
        posicionX: silo.posicionFisica ? Number.parseInt(silo.posicionFisica.slice(1, silo.posicionFisica.length - 1).split(',')[0]) : 0,
        posicionZ: silo.posicionFisica ? Number.parseInt(silo.posicionFisica.slice(1, silo.posicionFisica.length - 1).split(',')[1]) : 0,
        cerealVariedadConColor: {
          color: silo.color ? silo.color.trim() : silo.color,
          cerealVariedad: silo.cerealVariedad ? silo.cerealVariedad.trim() : silo.cerealVariedad
        },
        etiqueta: silo.etiqueta ? silo.etiqueta.trim() : silo.etiqueta,
        nombre: silo.nombre.trim(),
        nombreCortoToShow: ` ${silo.nombreCorto.trim()}  `,
        nombreCorto: silo.nombreCorto.trim(),
        nucleo: silo.nucleo ? silo.nucleo.trim() : silo.nucleo,
        observaciones: silo.observaciones ? silo.observaciones.trim() : silo.observaciones,
        sectorToShow: `  ${silo.sector.trim()} `,
        sector: silo.sector ? silo.sector.trim() : silo.sector,
        tipo: silo.tipo ? silo.tipo.trim() : silo.tipo,
        estadoToShow: silo.estado ? estadoToShowMap[silo.estado] : 'indefinido',
        fechaDeVaciado: silo.fechaDeVaciado ? silo.fechaDeVaciado.split('.')[0] : silo.fechaDeVaciado,
        fechaFinLlenado: silo.fechaFinLlenado ? silo.fechaFinLlenado.split('.')[0] : silo.fechaFinLlenado,
        fechaInicioLlenado: silo.fechaInicioLlenado ? silo.fechaInicioLlenado.split('.')[0] : silo.fechaInicioLlenado,
        fechaUltimoCubicaje: silo.fechaUltimoCubicaje ? silo.fechaUltimoCubicaje.split('.')[0] : silo.fechaUltimoCubicaje,
        fechaUltimoFumigado: silo.fechaUltimoFumigado ? silo.fechaUltimoFumigado.split('.')[0] : silo.fechaUltimoFumigado
      }))
      .map((silo) => ({ ...silo, operar: silo }))
  }

  static calculatePosicionEnXDesplazadaAlSector (posicionx, sector) {
    return sector === 'S4' ? (SECTORES_SIN_TORRES[sector].startingXPosition + SECTORES_SIN_TORRES[sector].xLarge / 3) + posicionx / 1.5
      : sector === 'S5' ? SECTORES_SIN_TORRES[sector].startingXPosition + posicionx * 2 + 1 : SECTORES_SIN_TORRES[sector].startingXPosition + posicionx
  }

  static parseDataForCerealPorLineaD3View (data) {
    return data.filas
  }

  static parseDataForCuadroDeMando (data) {
    const unificarLineaYSector = (silo) =>
      `${silo.linea ? silo.linea.trim().toUpperCase() + '-' : ''}${
        silo.sector
          ? silo.sector.trim().toUpperCase() === 'S1' || silo.sector.trim().toUpperCase() === 'S2'
            ? 'S1-2'
            : silo.sector.trim().toUpperCase()
          : silo.sector
      }`
    const desplazarPosXS3yS4yS5abajo = (silo) => {
      const pos = silo.posicionFisica
        ? this.calculatePosicionEnXDesplazadaAlSector(
          Number.parseInt(silo.posicionFisica.slice(1, silo.posicionFisica.length - 1).split(',')[0]),
          silo.sector ? silo.sector.trim() : silo.sector
        )
        : 0
      return pos
    }
    const desplazarPosZS3yS4yS5abajo = (silo) => {
      const pos = silo.posicionFisica ? Number.parseInt(silo.posicionFisica.slice(1, silo.posicionFisica.length - 1).split(',')[1]) : 0
      return silo.sector
        ? silo.sector.trim().toUpperCase() === 'S3' || silo.sector.trim().toUpperCase() === 'S4' || silo.sector.trim().toUpperCase() === 'S5'
          ? pos + (SECTORES_SIN_TORRES['S3'].startingZPosition)
          : pos + 3 : pos
    }
    return data.filas.map((silo) => ({
      ...silo,
      sector: silo.sector ? silo.sector.trim() : silo.sector,
      linea: unificarLineaYSector(silo),
      posicionX: desplazarPosXS3yS4yS5abajo(silo),
      posicionZ: desplazarPosZS3yS4yS5abajo(silo)
    }))
  }

  static parseDataForReportePorCerealYLinea (data, total) {
    return data ? [...data, { ...total, pesoNeto: total.pesoNetoBaseVigente, cereal: 'TOTAL' }] : []
  }
}
